import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, watch } from "vue";
import { ENABLED_FEATURES } from "@/util";
import {
  artifactGenerationApiStore,
  artifactStore,
  permissionStore,
} from "@/hooks";
import {
  Typography,
  FlexBox,
  TextButton,
  TextInput,
} from "@/components/common";


/**
 * Displays the selected node's summary, and allows for regenerating summaries.
 */
const __default__ = {
  name: "ArtifactSummary",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const displayActions = computed(
  () =>
    permissionStore.isAllowed("project.generate") &&
    ENABLED_FEATURES.GENERATE_SUMMARIES
);

const artifact = computed(() => artifactStore.selectedArtifact);

const generateConfirmation = computed(
  () => artifactGenerationApiStore.summaryGenConfirm
);

const summary = computed<string>({
  get() {
    return generateConfirmation.value?.summary || artifact.value?.summary || "";
  },
  set(value) {
    if (!generateConfirmation.value) return;

    generateConfirmation.value.summary = value;
  },
});

const hasSummary = computed(() => !!summary.value);
const generateApproval = computed(() => !!generateConfirmation.value);

/**
 * Generates a summary for the artifact.
 */
function handleGenerateSummary(): void {
  if (!artifact.value) return;

  artifactGenerationApiStore.handleGenerateSummary(artifact.value);
}

/**
 * Saves the generated summary for the artifact.
 */
function handleSaveSummary(): void {
  generateConfirmation.value?.confirm();
}

/**
 * Deletes the generated summary for the artifact.
 */
function handleDeleteSummary(): void {
  generateConfirmation.value?.clear();
}

watch(
  () => artifact.value,
  () => generateConfirmation.value?.clear()
);

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (hasSummary.value)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          justify: "between",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Typography), {
              variant: "caption",
              value: "Summary"
            }),
            (!generateApproval.value && displayActions.value)
              ? (_openBlock(), _createBlock(_unref(TextButton), {
                  key: 0,
                  text: "",
                  color: "primary",
                  loading: _unref(artifactGenerationApiStore).summaryGenLoading,
                  icon: hasSummary.value ? 'graph-refresh' : 'generate',
                  label: hasSummary.value ? 'Resummarize' : 'Summarize',
                  onClick: handleGenerateSummary
                }, null, 8, ["loading", "icon", "label"]))
              : (displayActions.value)
                ? (_openBlock(), _createBlock(_component_q_card, {
                    key: 1,
                    bordered: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TextButton), {
                        text: "",
                        icon: "save",
                        label: "Save",
                        onClick: handleSaveSummary
                      }),
                      _createVNode(_unref(TextButton), {
                        text: "",
                        loading: _unref(artifactGenerationApiStore).summaryGenLoading,
                        icon: "graph-refresh",
                        label: "Retry",
                        onClick: handleGenerateSummary
                      }, null, 8, ["loading"]),
                      _createVNode(_unref(TextButton), {
                        text: "",
                        icon: "delete",
                        label: "Delete",
                        onClick: handleDeleteSummary
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(FlexBox), { "full-width": "" }, {
      default: _withCtx(() => [
        (hasSummary.value && !generateApproval.value)
          ? (_openBlock(), _createBlock(_unref(Typography), {
              key: 0,
              "default-expanded": "",
              "collapse-length": 0,
              variant: "expandable",
              value: summary.value,
              "data-cy": "text-selected-body"
            }, null, 8, ["value"]))
          : (generateApproval.value)
            ? (_openBlock(), _createBlock(_component_q_card, {
                key: 1,
                bordered: "",
                class: "full-width q-pa-sm q-mt-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TextInput), {
                    modelValue: summary.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((summary).value = $event)),
                    label: "Generated Summary",
                    type: "textarea",
                    "hide-hint": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})